import { FC, SVGProps } from 'react';

export const GraphIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M26.7493 6.03361C26.7678 5.61982 26.4474 5.26931 26.0336 5.25073L19.2904 4.94797C18.8766 4.92939 18.5261 5.24978 18.5076 5.66358C18.489 6.07738 18.8094 6.42789 19.2232 6.44646L24.1575 6.66801L17.7816 12.496L12.6707 9.93321C12.3841 9.68485 11.9572 9.68947 11.6761 9.94399L5.49664 15.444C5.18958 15.722 5.16602 16.1963 5.44402 16.5033C5.72202 16.8104 6.19631 16.834 6.50337 16.556L12.1904 11.5019L17.3037 14.0667C17.5913 14.316 18.02 14.3103 18.3009 14.0536L25.1695 7.77517L24.948 12.7095C24.9294 13.1233 25.2498 13.4738 25.6636 13.4924C26.0774 13.511 26.4279 13.1906 26.4465 12.7768L26.7493 6.03361Z"
			fill="currentColor"
		/>
		<path
			d="M24 16.25C24.4142 16.25 24.75 16.5858 24.75 17V27C24.75 27.4142 24.4142 27.75 24 27.75C23.5858 27.75 23.25 27.4142 23.25 27V17C23.25 16.5858 23.5858 16.25 24 16.25Z"
			fill="currentColor"
		/>
		<path
			d="M18 21.25C18.4142 21.25 18.75 21.5858 18.75 22V27C18.75 27.4142 18.4142 27.75 18 27.75C17.5858 27.75 17.25 27.4142 17.25 27V22C17.25 21.5858 17.5858 21.25 18 21.25Z"
			fill="currentColor"
		/>
		<path
			d="M12 18.75C12.4142 18.75 12.75 19.0858 12.75 19.5V27C12.75 27.4142 12.4142 27.75 12 27.75C11.5858 27.75 11.25 27.4142 11.25 27V19.5C11.25 19.0858 11.5858 18.75 12 18.75Z"
			fill="currentColor"
		/>
		<path
			d="M6.75 23.5C6.75 23.0858 6.41421 22.75 6 22.75C5.58579 22.75 5.25 23.0858 5.25 23.5V27C5.25 27.4142 5.58579 27.75 6 27.75C6.41421 27.75 6.75 27.4142 6.75 27V23.5Z"
			fill="currentColor"
		/>
	</svg>
);
